
export function initDebug(options = {}) {
  const cfg = {
    enableHooks: true,
    enableCLS: true,
    enableScans: true,
    watchHeader: true,
    watchVisBox: true,
    setScrollRestoration: true,
    setNoSmooth: true,
    stabilizeVH: true,
    neutralizeHashAnchors: false, 
    ...options
  };

  
  if (cfg.setNoSmooth) {
    try { document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important'); } catch {}
  }
  if (cfg.setScrollRestoration && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  
  const updateVHAndHeaderSpacer = (() => {
    let t;
    const setVH = () => {
      const h = window.visualViewport ? visualViewport.height : window.innerHeight;
      document.documentElement.style.setProperty('--vh', h + 'px');
    };
    const setHeaderSpacer = () => {
      const hdr = document.querySelector('#weros-header');
      const sp  = document.querySelector('#header-spacer[aria-hidden="true"]');
      if (!hdr || !sp) return;
      const h = hdr.offsetHeight;
      sp.style.setProperty('--header-h', h + 'px');
      sp.style.height = h + 'px';
    };
    const apply = () => { setVH(); setHeaderSpacer(); };
    const debounced = () => { clearTimeout(t); t = setTimeout(apply, 120); };
    return { apply, debounced };
  })();

  if (cfg.stabilizeVH) {
    updateVHAndHeaderSpacer.apply();
    window.addEventListener('resize', updateVHAndHeaderSpacer.debounced, { passive: true });
    if (window.visualViewport) {
      visualViewport.addEventListener('resize', updateVHAndHeaderSpacer.debounced, { passive: true });
    }
  }

  
  if (cfg.enableHooks) {
    try {
      const _wst = window.scrollTo; window.scrollTo = function(...a){ return _wst.apply(this,a); };
      const _wsb = window.scrollBy; window.scrollBy = function(...a){ return _wsb.apply(this,a); };

      const EP = Element.prototype;
      const _siv = EP.scrollIntoView; EP.scrollIntoView = function(...a){ return _siv.apply(this,a); };
      const _est = EP.scrollTo; if (_est) EP.scrollTo = function(...a){ return _est.apply(this,a); };

      const proto = Object.getPrototypeOf(window.location);
      const desc = Object.getOwnPropertyDescriptor(proto, 'hash');
      if (desc && desc.configurable) {
        Object.defineProperty(proto,'hash',{
          get(){ return desc.get.call(this); },
          set(v){ return desc.set.call(this, v); }
        });
      }
      const _push = history.pushState; history.pushState = function(...a){ return _push.apply(this,a); };
      const _rep  = history.replaceState; history.replaceState = function(...a){ return _rep.apply(this,a); };

      const _focus = HTMLElement.prototype.focus; HTMLElement.prototype.focus = function(...a){ return _focus.apply(this,a); };
    } catch(e) {
    }
  }

  
  if (cfg.enableCLS && 'PerformanceObserver' in window) {
    try {
      const obs = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (!entry || entry.hadRecentInput) continue;
        }
      });
      obs.observe({ type: 'layout-shift', buffered: true });
    } catch(e) { }
  }

  
  if (cfg.enableScans) {
    try {
      const all = Array.from(document.querySelectorAll('*'));
      const badSnap = all.filter(el => getComputedStyle(el).scrollSnapType !== 'none');
      const badOverflow = all.filter(el => {
        const cs = getComputedStyle(el);
        return /(auto|scroll)/.test(cs.overflow + cs.overflowY + cs.overflowX);
      });
      const transformedRoots = all.filter(el => {
        const cs = getComputedStyle(el);
        return cs.transform !== 'none' || cs.perspective !== 'none' || cs.filter !== 'none';
      });

      const isSticky = el => ['sticky','-webkit-sticky'].includes(getComputedStyle(el).position);
      const stickies = Array.from(document.querySelectorAll('*')).filter(isSticky);
      const transformed = (el) => {
        for (let p = el.parentElement; p; p = p.parentElement) {
          const cs = getComputedStyle(p);
          if (cs.transform !== 'none' || cs.perspective !== 'none' || cs.filter !== 'none') return p;
        }
        return null;
      };
      const conflicts = stickies.map(el => ({el, transformedAncestor: transformed(el)})).filter(x=>x.transformedAncestor);
    } catch(e) { }
  }

  
  if (cfg.watchHeader) {
    const header = document.querySelector('header#weros-header');
    if (header) {
      const last = { h: null, mt:null, pt:null, trf:null, top:null, cls:'' };
      const snap = (why) => {
        const cs = getComputedStyle(header);
        const cur = {
          h: header.offsetHeight,
          mt: cs.marginTop, pt: cs.paddingTop,
          trf: cs.transform, top: cs.top,
          cls: header.className
        };
        const changed = Object.keys(cur).filter(k => cur[k] !== last[k]);
        if (changed.length) {
          Object.assign(last, cur);
        }
      };
      snap('init');
      addEventListener('scroll', () => snap('scroll'), {passive:true});
      addEventListener('resize', () => snap('resize'));
      if (window.visualViewport) visualViewport.addEventListener('resize', () => snap('vv.resize'));
    }
  }

  
  if (cfg.watchVisBox) {
    const els = document.querySelectorAll('.vis-statement-catcher-box');
    if (els.length) {
      const map = new WeakMap();
      const ro = new ResizeObserver(list => {
        list.forEach(e => {
          const last = map.get(e.target) || {w:0,h:0};
          const now  = {w:Math.round(e.contentRect.width), h:Math.round(e.contentRect.height)};
          if (Math.abs(now.w - last.w) > 1 || Math.abs(now.h - last.h) > 1) {
            map.set(e.target, now);
          }
        });
      });
      els.forEach(el => ro.observe(el));
    }
  }

  
  (() => {
    let userScroll = false;
    const on  = () => { userScroll = true;  };
    const off = () => { userScroll = false; };
    addEventListener('touchstart', on, {passive:true});
    addEventListener('touchend',   off, {passive:true});
    addEventListener('wheel',      on, {passive:true});
    let lastY = pageYOffset;
    setInterval(() => {
      const y = pageYOffset;
      const dy = Math.abs(y - lastY);
      if (dy > 80 && !userScroll) { }
      lastY = y;
    }, 60);
  })();

  
  if (cfg.neutralizeHashAnchors) {
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => e.preventDefault(), {capture:true});
    });
  }

}
